export const TEAM_LIST: {
  label: string;
  member: { name: string; link: string }[];
}[] = [
  {
    label: "开发",
    member: [{ name: "Golder", link: "https://github.com/GolderV" }],
  },
  {
    label: "紫云山影神图",
    member: [
      {
        name: "《【影神图】紫云山》",
        link: "https://tieba.baidu.com/p/8600775267",
      },
    ],
  },
  {
    label: "图鉴汇总",
    member: [
      {
        name: "《黑神话已曝光怪物图鉴大汇总》",
        link: "https://tieba.baidu.com/p/8600775267",
      },
    ],
  },
  {
    label: "原画&截图",
    member: [
      {
        name: "《黑神话吧图集》",
        link: "https://tieba.baidu.com/f?kw=%E9%BB%91%E7%A5%9E%E8%AF%9D&tab=album",
      },
    ],
  },
];
